import { ApiError } from '../../../shared/api'
import type { Lieferstelle, LieferstellenKind, LieferstellenLocation } from '../api/lieferstellenApi'

export const KINDS: Record<LieferstellenKind, { label: string; icon: string; color: string }> = {
  eingang: { label: 'Eingang', icon: 'door_front', color: '#0e7490' },
  mensa: { label: 'Mensa/Küche', icon: 'restaurant', color: '#d9480f' },
  anlieferung: { label: 'Anlieferung', icon: 'move_to_inbox', color: '#8b5fbf' },
  parkplatz: { label: 'Parkplatz', icon: 'local_parking', color: '#3f72b8' },
  hinweis: { label: 'Hinweis', icon: 'info', color: '#b7791f' },
  weg: { label: 'Fußweg', icon: 'directions_walk', color: '#475569' },
}
export const KIND_ORDER = Object.keys(KINDS) as LieferstellenKind[]
export const REDUCED_MOTION = '(prefers-reduced-motion: reduce)'

/** Distance in metres between two [lat, lon] points. */
export function distanceMeters(a: [number, number], b: [number, number]): number {
  const rad = Math.PI / 180
  const h = Math.sin((b[0] - a[0]) * rad / 2) ** 2 +
    Math.cos(a[0] * rad) * Math.cos(b[0] * rad) * Math.sin((b[1] - a[1]) * rad / 2) ** 2
  return 12742000 * Math.asin(Math.sqrt(h))
}

export const LOCATION_TYPES = [
  { value: 'alle', label: 'Alle' },
  { value: '1', label: 'Schule' },
  { value: '2', label: 'Außer-Haus' },
  { value: '3', label: 'Ferien' },
  { value: '4', label: 'HQ' },
] as const

export function locationPosition(location: Pick<LieferstellenLocation, 'lat' | 'lon'> | null): [number, number] | null {
  if (location?.lat == null || location.lon == null) return null
  const lat = Number(location.lat)
  const lon = Number(location.lon)
  return Number.isFinite(lat) && Number.isFinite(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180 ? [lon, lat] : null
}

export function navigationUrl(location: LieferstellenLocation, marks: Lieferstelle[]): string | null {
  const target = ['parkplatz', 'anlieferung', 'eingang']
    .map(kind => marks.find(mark => mark.kind === kind))
    .find(Boolean) ?? location
  const position = locationPosition(target)
  return position ? `https://www.google.com/maps/dir/?api=1&destination=${position[1]},${position[0]}&travelmode=driving` : null
}

export function lieferstellenError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.'
    if (error.status === 403) return 'Dir fehlt die Berechtigung für diese Aktion.'
    if (error.status === 404) return 'Der Standort oder die Markierung ist nicht mehr verfügbar. Bitte lade die Liste neu.'
    if (error.status === 400) return 'Die Änderung konnte nicht gespeichert werden. Prüfe die Eingaben und versuche es erneut.'
  }
  return 'Die Daten konnten nicht übertragen werden. Bitte prüfe deine Verbindung und versuche es erneut.'
}
